	<div class="footer-middle style-four pt-160"> 
		<div class="container">
			<div class="row">
				<div class="col-lg-4 col-md-4">
					<div class="widget widgets-company-info wow fadeInLeft" data-wow-delay=".4">
						<div class="footer-bottom-logo pb-30">
							<img class="down" src="../../../assets/images/logos/wm-white.png" alt="" class="logo-img">
							<span class="logo-text">Web <br /> Monkeyz</span>
						</div>
						<div class="company-info-desc">
							<p>Be a part of our journey. <br />Follow us on our social media platforms</p>
						</div>
						<div class="follow-company-info pt-2">
							<div class="follow-company-icon">
								<a class="social-icon-color" href="https://www.facebook.com/webmonkeyz" target="_blank"> <i class="fa fa-facebook"> </i> </a>
								<a class="social-icon-color2" href="https://www.instagram.com/webmonkeyz" target="_blank"> <i class="bi bi-instagram"> </i> </a>
								<a class="social-icon-color1" href="https://www.linkedin.com/company/web-monkeyz" target="_blank"> <i class="bi bi-linkedin"> </i> </a>

							</div>
						</div>
					</div>					
				</div>
				<div class="col-lg-4 col-md-4">
					<div class="widget widget-nav-menu wow fadeInDown" data-wow-delay=".5">
						<h4 class="widget-title pb-30">Quick Links</h4>
						<div class="menu-quick-link-container ml-4">
							<ul id="menu-quick-link" class="menu">
								<li><a href="#home"> Home </a></li>
								<li><a href="#about"> About Us </a></li>
								<li><a href="#services"> Our Services </a></li>
								<li><a href="#contact"> Contact Us </a></li>
							</ul>
						</div>
					</div>
				</div>	
				<div class="col-lg-4 col-md-4">
					<div class="widget widgets-company-info wow fadeInRight" data-wow-delay=".7">
						<h3 class="widget-title pb-30">Contact Info</h3>
						<div class="company-info-desc">
							<div class="company-icon">
								<a href="mailto:info@webmonkeyz.com"><i class="bi bi-envelope-open"></i></a>
							</div>
							<div class="company-info-title">
								<h6>Email Us</h6>
								<p><a href="mailto:info@webmonkeyz.com" style="color:white !important">info@webmonkeyz.com</a></p>
							</div>
						</div>
						<div class="company-info-desc">
							<div class="company-icon">
								<a href="tel:+35679062651"><i class="bi bi-telephone-plus"></i></a>
							</div>
							<div class="company-info-title">
								<h6>Phone Us</h6>
								<p><a href="tel:+35679062651" style="color:white !important">+356 79062651</a></p>
							</div>
						</div>
						
					</div>					
				</div>
				
				
			</div>
			<div class="row footer-bottom mt-20 pt-3 pb-1">
				<div class="col-lg-6 col-md-6">
					<div class="footer-bottom-content wow fadeInLeft" data-wow-delay=".8">
						<div class="footer-bottom-content-copy">
							<p>© {{year}} Web Monkeyz. All Rights Reserved. </p>
						</div>
					</div>
				</div>
				<div class="col-lg-6 col-md-6">
					<div class="footer-bottom-right wow fadeInRight" data-wow-delay=".9">
						<!-- <div class="footer-bottom-right-text">
							<a class="absod" href="#">Privacy Policy </a>
							<a href="#"> Terms & Conditions</a>
						</div> -->
					</div>
				</div>
			</div>
		</div>
	</div>		
	